import React, {useMemo} from 'react'
import {Button, Card, Col, Row} from 'react-bootstrap'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../../setup'
import {Link} from 'react-router-dom'
import {CurrencyUtils} from '../../../../services/Functional'

const TotalCheckOutPrice = () => {
  const {actionsLoading, cartItem}: any = useSelector<RootState>(
    (state) => ({
      actionsLoading: state.common.actionsLoading,
      cartItem: state.bookings.cartItem,
    }),
    shallowEqual
  )

  const totalAmount = useMemo(() => {
    const hotelTotal =
      cartItem.hotels?.reduce((total: number, hotel: any) => {
        const roomPrices = hotel.room_info.map(
          (room: {roomData: {price: string}}) => room.roomData.price
        )
        const hotelTotalPrice = CurrencyUtils.sum(roomPrices)
        return CurrencyUtils.add(total, hotelTotalPrice)
      }, 0) || 0

    const sightSeeingTotal =
      cartItem.sightSeeings?.reduce(
        (total: number, item: any) => CurrencyUtils.add(total, item?.price || 0),
        0
      ) || 0

    const packageTotal =
      cartItem.packages?.reduce(
        (total: number, item: any) => CurrencyUtils.add(total, item?.price || 0),
        0
      ) || 0

    const transferTotal =
      cartItem.transfers?.reduce(
        (total: number, item: any) => CurrencyUtils.add(total, item?.price || 0),
        0
      ) || 0

    return CurrencyUtils.sum([hotelTotal, sightSeeingTotal, packageTotal, transferTotal])
  }, [cartItem])
  return (
    <React.Fragment>
      <Card className={'gutter-b'}>
        <Card.Body>
          <Row className={'mb-2'}>
            <Col md={12}>
              <h2>Total</h2>
              <div className={'fs-2 text-danger fw-semibold'}>
                USD: {CurrencyUtils.format(totalAmount)}
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Link to={'/checkout/details'}>
                <Button size={'lg'} className={'mb-2 w-100 px-2'}>
                  Processed Next
                </Button>
              </Link>
            </Col>
            <Col md={12}>
              <Link to={'/quotations/create'} className={'mb-2 px-2 btn btn-sm btn-danger w-100'}>
                Add More Services
              </Link>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </React.Fragment>
  )
}

export {TotalCheckOutPrice}
